import { dataProps } from './properties'

export const setTeamCategoryList = (state, payload) => {
    state.list = payload
}    

export const setTeamCategoryData = (state, payload) => {
    state.props = payload
} 

export const resetTeamCategoryData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/teamCategory/mutations.js